<template>
  <div class="container">
    <div class="location">
      <div class="location__image">
        <img src="@/assets/img/map.png" />
      </div>
      <div class="location__text">
        <div class="location__text--title">{{ $t('location.title') }}</div>
        <div class="location__text--subtitle">
          {{ $t('location.subtitle') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
  @import '@/scss/mixings';
  .location {
    @include d-flex(column, center, center);
    gap: 6.25vh;
    padding: 22.36vh 11.23vw 0 11.23vw;
    &__text {
      @include d-flex(column, center, center);
      gap: 1.25vh;
      font-family: 'OpenSansRegular';
      &--title {
        font-size: 4.14vw;
        font-weight: var(--fw-medium);
      }
      &--subtitle {
        font-size: 3.22vw;
        font-weight: var(--fw-ligther);
      }
    }
  }
</style>
